import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import PersonIcon from "@material-ui/icons/Person";
import ModalImage from "react-modal-image";

import useContactProfilePic from "../../hooks/useContactProfilePic";

const useStyles = makeStyles(() => ({
	messageMedia: {
		objectFit: "cover",
		margin: 15,
		width: 160,
		height: 160,
		borderRadius: 10,
	},
	placeholder: {
		margin: 15,
		width: 160,
		height: 160,
		borderRadius: 10,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "#e0e0e0",
	},
}));

function ModalImageContatc({ imageUrl, contactId, channel }) {
	const classes = useStyles();
	const { src, failed } = useContactProfilePic({
		contactId,
		profilePicUrl: imageUrl,
		channel,
	});

	if (!src || failed) {
		return (
			<div className={classes.placeholder} aria-hidden>
				<PersonIcon style={{ fontSize: 80, color: "#9e9e9e" }} />
			</div>
		);
	}

	return (
		<ModalImage
			className={classes.messageMedia}
			small={src}
			medium={src}
			large={src}
			showRotate
			alt=""
		/>
	);
}

export default ModalImageContatc;
